import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { MapperAnagCampoSpecifico } from "../mapper/anagrafe/mapper-anag-campo-specifico";
import { AnagraficaCampoSpecificoVO } from "../vo/anagrafica-campo-specificoVO";
import { AnagraficaCampoSpecificoDTO } from "../dto/anagrafica-campo-specificoDTO";
import { env } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class AnagCampiSpecificiService {
  private urlAnagCampiSpecifici: string;

  constructor(
    private httpClient: HttpClient,
    private mapperAnagCampiSpecifici: MapperAnagCampoSpecifico,

  ) {
    this.urlAnagCampiSpecifici =
     env.API_URL_BASE + env.API_ANAG_CAMPI_SPECIFICI;
  }

  getAnagCampoSpecifico(id: string): Observable<AnagraficaCampoSpecificoVO> {
    return this.httpClient
      .get<AnagraficaCampoSpecificoDTO>(this.urlAnagCampiSpecifici + "/" + id)
      .pipe(
        map((response) =>
          this.mapperAnagCampiSpecifici.convertDtoToVo(response)
        ),
        catchError((err) => {
          console.log(
            "[AnagCampiSpecificiService.getAnagCampoSpecifico] err:",
            err
          );
          return throwError(err);
        })
      );
  }
}
